import React from 'react';
import styles from "./ListItem.module.scss";
import { flag } from '../../../utilities/utils';
import { getCountryISO2 } from '../../../utilities/converter';

const ListItem = ({id, style, onMouseOver, onMouseOut, onClick, data}) =>{


    return( 
                <div
                    id={id}
                    style={style}
                    onMouseOver={onMouseOver}
                    onMouseOut={onMouseOut}
                    onClick={onClick} 
                    className={styles.listItem}>
             
                        <img src={flag(getCountryISO2(data.countryCode))} alt={data.country} className={styles.flag} />
                        <span>{data.country}</span>
                 
                </div>

    )
}

export default ListItem;